export var updateTo = function (to, params) {
    var entries = Object.entries(params);
    var path = "".concat(to);
    entries.forEach(function (_a) {
        var key = _a[0], value = _a[1];
        path = path.replace(":".concat(key), "".concat(value));
    });
    return path;
};
